import axios from "axios";
import { API } from "../../constants/constants";

export const START_CORRO_LINK_MUTATION = `
mutation StartCorroLink($trackingId: String!) {
    items: startCorroLink(trackingId: $trackingId) {
		status
		sessionId
		themeName
		cmsTag
	}
}`;

export const SELECT_CUSTOMER_MUTATION = `
mutation SelectCustomerCorroLink($trackingId: String!, $sessionId: String!, $recipient: String!) {
    items: selectCustomerCorroLink(trackingId: $trackingId, sessionId: $sessionId, recipient: $recipient) {
		status
		customerId
		recipient
	}
}`;

export const VERIFY_SMS_CORRO_LINK_MUTATION = `
mutation VerifySmsCorroLink($trackingId: String!, $sessionId: String!, $customerId: String!, $passCode: String!) {
    items: verifySmsCorroLink(trackingId: $trackingId, sessionId: $sessionId, customerId: $customerId, passCode: $passCode) {
		status
		attachments {
			fileName
			mimeType
			base64
		}
		createdAt
		policyDetails
    	policyNumber
    	claimNumber
    	lifeInsured
    }
}`;

export const RESEND_CORRO_LINK_VERIFICATION_MUTATION = `
mutation ResendCorroLinkOtp($trackingId: String!, $sessionId: String!, $customerId: String!) {
    items: resendCorroLinkOtp(trackingId: $trackingId, sessionId: $sessionId, customerId: $customerId) {
		status
	}
}`;

export async function CorroLinkGraphQL<
  V extends Record<string, unknown>,        // variables shape
  T                                          // the model for items[]
>(query: string, variables: V): Promise<T> {
  type AxiosResp = { data: { data: { items: T } } };

  const res = await axios.post<AxiosResp>(API.BASEURL, { query, variables });
  return res.data.data.items;
}